export enum DockyardStatus {
  IN_PROGRESS = "in_progress",
  DONE = "done",
}
